import { type PropsWithChildren } from 'react';

const FieldHelpText: React.FC<PropsWithChildren> = ({ children }) => (
  <p
    style={{
      fontSize: 12,
      margin: 0,
      marginTop: 8,
      textAlign: 'left',
    }}
  >
    {children}
  </p>
);

export default FieldHelpText;
